// extracted by mini-css-extract-plugin
export default {"wrapper":"infinite-pagination_wrapper__1ZVhk","spinner":"infinite-pagination_spinner__QaeQZ"};